import config from 'src/config';
import loginStorageService from 'src/app/login/services/login-storage-service';

export const redirectToShopify = () => {
    if (config.shopifyRedirectUrl) {
        loginStorageService.setRedirectPath('');
        window.location.assign(config.shopifyRedirectUrl);
    } else {
        console.error('Unable to redirect to Shopify');
    }
};
